



































import AuthMixin from "@/components/templates/loggedin/authMixin";
import {Component} from "vue-property-decorator";
import MailAddressBanner from "@/components/domains/auth/MailAddressBanner.vue";
import PasskeyOfferBanner from "@/components/domains/auth/PasskeyOfferBanner.vue";

@Component({
  components: {MailAddressBanner, PasskeyOfferBanner}
})
export default class LoggedInTemplate extends AuthMixin {
  name = "LoggedInTemplate";
}
